export default "__VITE_ASSET__adb0d6c7__"